import { withContainer } from '@/hocs/withContainer'

import { StyledTable, StyledTableWrapper } from './styles'

import { TableBody } from './TableBody'
import { TableHead } from './TableHead'

import type { TableProps } from './types'

const TableBlock = ({
  headings = [],
  rows = [],
  roundedCorners = true,
  position = 'left',
  fontWeight = '400',
}: TableProps) => {
  const commonProps = { fontWeight }
  const hasMoreThanThreeColumns = headings.length > 3
  const styledTableProps = { roundedCorners, position, hasMoreThanThreeColumns, ...commonProps }
  return (
    <StyledTableWrapper>
      <StyledTable {...styledTableProps}>
        <TableHead headings={headings} {...commonProps} />
        <TableBody rows={rows} {...commonProps} />
      </StyledTable>
    </StyledTableWrapper>
  )
}

export default withContainer(TableBlock, {})
